import React from 'react';
import { Trans } from '@lingui/macro';
import { Link } from 'react-router-dom';

import NotificationStep from '../../components/NotificationStep/';
import Row from '../../components/Row/';
import { Typography } from 'components';

import { history } from '../../routers/AppRouter';
import * as routes from '../../settings/_routesSettings';

const NpsResponse = ({ location }) => {

  const PROFESSIONAL_ROUTES = {
    TVTVPSIC: {
      profile: routes.PROFESSIONAL_PSIC_PROFILE(location.state.next),
      homepage: routes.HOME_PSIC
    },
    TVTVPSIQ: {
      profile: routes.PROFESSIONAL_PSIQ_PROFILE(location.state.next),
      homepage: routes.HOME_PSIQ
    }
  }

  const professionalProfileCode = location.state.professional_profile_code

  const evalueationResponse = () => (
    <>
      <Row margin="1.5rem 0 0 0" justify="center">
        <div className="Response__heading">
          <Typography 
            type='heading2'
            align="center" >
            <Trans>
              Agradecemos sua avaliação!
            </Trans>
          </Typography>
        </div>
      </Row>
      <Row margin="1.5rem 0 2rem 0" align='center' justify= 'center'>
        <Typography
          align="center">
          <Trans>
            A psicoterapia é um processo de autoconhecimento que requer continuidade.
          </Trans>
        </Typography>
      </Row>
      <Row align='center' justify= 'center'>
        <Typography
          align="center">
          <Trans>
          Vimos que você não gostou tanto do profissional, <span className='ResponseTextBold'>que tal fazer uma nova tentativa com outro especialista?</span>
          </Trans>
        </Typography>
      </Row>

    </>
  )

  const responseViewOther = () => (
    <>
      <Row justify="center" margin="1.5rem 0 0 0">
        <div className="Responseheading">
          <Typography 
            type='heading2'
            align="center" >
            <Trans>
              Agradecemos sua avaliação!
            </Trans>
          </Typography>
        </div>
      </Row>
      <Row margin="1.5rem 0 0 0" align='center' justify= 'center'>
        <Typography
          align="center">
          <Trans>
            A psicoterapia é um processo de autoconhecimento que requer continuidade.
          </Trans>
        </Typography>
      </Row>
      <Row align='center' justify= 'center'>
        <Typography
          align="center">
          <Trans>
            <span className='ResponseTextBold'>Que tal marcar sua próxima sessão?</span>
          </Trans>
        </Typography>
      </Row>

    </>
  )

  const filterRating = (rating) => {
    const professionalRating = rating.filter((el) => el.question_code === "QET01002");
    return professionalRating.map(el => el.answer);
  }

  const handleNavigateToProfessionalProfile = () => {
    history.push(PROFESSIONAL_ROUTES[professionalProfileCode].profile)
  }

  const handleNavigateToHomepage = () => {
    history.push(PROFESSIONAL_ROUTES[professionalProfileCode].homepage)
  }

  const ratingValue = filterRating(location.state.professionalRating)[0];

  return (
    <div className="Response">
      <Row justify="center">
        <NotificationStep buttonId={`1`}
          btnText={ratingValue > 6 ? `MARCAR PRÓXIMA SESSÃO` : `ESCOLHER OUTRO PROFISSIONAL`}
          iconName="ResponseEmoji"
          mainText={(
            <div className="Response__container">
              {ratingValue > 6 ? responseViewOther() : evalueationResponse()}
            </div>

          )}
          onSuccessClick={ratingValue > 6 ? handleNavigateToProfessionalProfile : handleNavigateToHomepage}
        />

      </Row>
      <Row margin="1.5rem 0 0 0"
        justify="center">
        <Typography
          align="center">
          <Trans>
            Ir para <Link to={routes.DASHBOARD_APPOINTMENTS}><span className='ResponseTextBold'>minhas consultas</span></Link>
          </Trans>
        </Typography>
      </Row>
    </div>
  );

}

export default NpsResponse;
